/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentNotifyReqVo
 */
export interface PaymentNotifyReqVo {
    /**
     * 商户服务ID
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    sERVICEID?: string;
    /**
     * 支付方式服务代码
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    sERVICECODE?: string;
    /**
     * 商户订单号
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    oRDERID?: string;
    /**
     * 订单时间
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    oRDERDATE?: string;
    /**
     * 响应结果代码（0000=成功，1111=取消，其它=失败）
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    rESPONSECODE?: string;
    /**
     * 响应消息
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    rESPONSEMESSAGE?: string;
    /**
     * 详细响应代码
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    dETAILRESPONSECODE?: string;
    /**
     * 详细响应消息
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    dETAILRESPONSEMESSAGE?: string;
    /**
     * 预留字段1
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    rESERVED1?: string;
    /**
     * 预留字段2
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    rESERVED2?: string;
    /**
     * 预留字段3
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    rESERVED3?: string;
    /**
     * 消息
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    mESSAGE?: string;
    /**
     * 校验和
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    cHECKSUM?: string;
    /**
     * 哈希数据
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    hASHDATA?: string;
    /**
     * 支付消息
     * @type {string}
     * @memberof PaymentNotifyReqVo
     */
    pAYMESSAGE?: string;
}

/**
 * Check if a given object implements the PaymentNotifyReqVo interface.
 */
export function instanceOfPaymentNotifyReqVo(value: object): value is PaymentNotifyReqVo {
    return true;
}

export function PaymentNotifyReqVoFromJSON(json: any): PaymentNotifyReqVo {
    return PaymentNotifyReqVoFromJSONTyped(json, false);
}

export function PaymentNotifyReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentNotifyReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'sERVICEID': json['SERVICE_ID'] == null ? undefined : json['SERVICE_ID'],
        'sERVICECODE': json['SERVICE_CODE'] == null ? undefined : json['SERVICE_CODE'],
        'oRDERID': json['ORDER_ID'] == null ? undefined : json['ORDER_ID'],
        'oRDERDATE': json['ORDER_DATE'] == null ? undefined : json['ORDER_DATE'],
        'rESPONSECODE': json['RESPONSE_CODE'] == null ? undefined : json['RESPONSE_CODE'],
        'rESPONSEMESSAGE': json['RESPONSE_MESSAGE'] == null ? undefined : json['RESPONSE_MESSAGE'],
        'dETAILRESPONSECODE': json['DETAIL_RESPONSE_CODE'] == null ? undefined : json['DETAIL_RESPONSE_CODE'],
        'dETAILRESPONSEMESSAGE': json['DETAIL_RESPONSE_MESSAGE'] == null ? undefined : json['DETAIL_RESPONSE_MESSAGE'],
        'rESERVED1': json['RESERVED1'] == null ? undefined : json['RESERVED1'],
        'rESERVED2': json['RESERVED2'] == null ? undefined : json['RESERVED2'],
        'rESERVED3': json['RESERVED3'] == null ? undefined : json['RESERVED3'],
        'mESSAGE': json['MESSAGE'] == null ? undefined : json['MESSAGE'],
        'cHECKSUM': json['CHECK_SUM'] == null ? undefined : json['CHECK_SUM'],
        'hASHDATA': json['HASH_DATA'] == null ? undefined : json['HASH_DATA'],
        'pAYMESSAGE': json['PAY_MESSAGE'] == null ? undefined : json['PAY_MESSAGE'],
    };
}

export function PaymentNotifyReqVoToJSON(json: any): PaymentNotifyReqVo {
    return PaymentNotifyReqVoToJSONTyped(json, false);
}

export function PaymentNotifyReqVoToJSONTyped(value?: PaymentNotifyReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SERVICE_ID': value['sERVICEID'],
        'SERVICE_CODE': value['sERVICECODE'],
        'ORDER_ID': value['oRDERID'],
        'ORDER_DATE': value['oRDERDATE'],
        'RESPONSE_CODE': value['rESPONSECODE'],
        'RESPONSE_MESSAGE': value['rESPONSEMESSAGE'],
        'DETAIL_RESPONSE_CODE': value['dETAILRESPONSECODE'],
        'DETAIL_RESPONSE_MESSAGE': value['dETAILRESPONSEMESSAGE'],
        'RESERVED1': value['rESERVED1'],
        'RESERVED2': value['rESERVED2'],
        'RESERVED3': value['rESERVED3'],
        'MESSAGE': value['mESSAGE'],
        'CHECK_SUM': value['cHECKSUM'],
        'HASH_DATA': value['hASHDATA'],
        'PAY_MESSAGE': value['pAYMESSAGE'],
    };
}

